import React from 'react';
import * as S from "./style";
import Image from  '../../../components/loggedout/common/Image';
import { Link } from 'react-router-dom';
import PlayableGroup1Img from "~images/oddbods/train1.png";
import PlayableGroup2Img from "~images/oddbods/train2.png";
import { CTAOfferButton } from "../../../../../landing-pages/js/common/styled-components/styled-components";
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';

const Playables = ({btnClickEvent, ctaText, urlToRedirect }) => {
  // let ctaText = 'Sign up for free';
  return (
    <S.ContainerWrapper>
      <S.HeadingText>Explore <S.HighlightText>4000+</S.HighlightText> math &amp; reading games, educational activities, and books</S.HeadingText>
      <S.PlayableWrapper>
        <S.PlayableGroupFirst>
          <Image alt="image" src={PlayableGroup1Img} />
        </S.PlayableGroupFirst>
        <S.PlayableGroupSecond>
          <Image alt="image" src={PlayableGroup2Img} />
        </S.PlayableGroupSecond>
      </S.PlayableWrapper>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor="#090A4A" fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <a href={urlToRedirect} onClick={btnClickEvent}>
            {ctaText}
          </a>
        </CTAOfferButton>
      </S.ButtonWrapper>
    </S.ContainerWrapper>
  )
}

export default Playables